import { Outlet, Link } from 'react-router-dom'
import './AuthLayout.css'

export default function AuthLayout() {
    return (
        <div className="auth-layout">
            <div className="auth-header">
                <Link to="/" className="auth-logo">
                    <span className="gradient-text">4ge</span>
                </Link>
            </div>

            <div className="auth-container">
                <div className="auth-card">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
